import { render, staticRenderFns } from "./CommonFieldCheck.vue?vue&type=template&id=71dbbcea&scoped=true"
import script from "./CommonFieldCheck.vue?vue&type=script&lang=js"
export * from "./CommonFieldCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dbbcea",
  null
  
)

export default component.exports